import React from "react";

const MongoDBIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_927_4549)">
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#13AA52"/>
    <path d="M15.2077 10.5338C14.4497 7.18852 12.6584 6.08859 12.4655 5.66836C12.2545 5.37188 12.0408 4.84453 12.0408 4.84453C12.0373 4.83562 12.0317 4.81992 12.0251 4.80469C12.0033 5.10117 11.992 5.21555 11.7117 5.51461C11.2777 5.85398 9.05063 7.72266 8.86946 11.5233C8.70048 15.068 11.43 17.1802 11.7992 17.4495L11.8411 17.4792V17.4766C11.8434 17.4945 11.9583 18.3204 12.0389 19.1955H12.3281C12.396 18.5769 12.4977 17.9625 12.6328 17.355L12.6563 17.3398C12.8214 17.2214 12.9788 17.0926 13.1276 16.9542L13.1445 16.939C13.9292 16.2141 15.3399 14.5373 15.326 11.8641C15.3231 11.4181 15.2835 10.9732 15.2077 10.5338ZM12.0082 15.4481C12.0082 15.4481 12.0082 10.4766 12.1723 10.4775C12.3002 10.4775 12.4659 16.8902 12.4659 16.8902C12.2381 16.8628 12.0082 15.8348 12.0082 15.4481Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_927_4549">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>
);

export default MongoDBIcon;